var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 13.4584 46.5416 0 30 0C13.4584 0 0 13.4584 0 30C0 46.5416 13.4584 60 30 60C46.5416 60 60 46.5416 60 30ZM2.99755 30C2.99755 15.1101 15.1101 2.99755 30 2.99755C44.8899 2.99755 57.0024 15.1101 57.0024 30C57.0024 44.8899 44.8899 57.0024 30 57.0024C15.1101 57.0024 2.99755 44.8899 2.99755 30Z",
    fill: "#0C1220"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0636 44.0945L39.4935 35.6647C40.0808 35.0774 40.0808 34.1353 39.4935 33.548C38.9062 32.9608 37.9641 32.9608 37.3769 33.548L31.5041 39.4208V16.9697C31.5041 16.1378 30.8312 15.4648 29.9992 15.4648C29.1672 15.4648 28.4943 16.1378 28.4943 16.9697V39.4086L22.6215 33.5358C22.0343 32.9485 21.0922 32.9485 20.5049 33.5358C19.9176 34.1231 19.9176 35.0652 20.5049 35.6524L28.9348 44.0823C29.2284 44.3759 29.6077 44.5228 29.9992 44.5228C30.3907 44.5228 30.77 44.3882 31.0636 44.0945Z",
    fill: "#0C1220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroArrowDown);
export default __webpack_public_path__ + "static/media/intro-arrow-down.32d4024d4bbfe0777e79c2ab3c51a735.svg";
export { ForwardRef as ReactComponent };